import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#ffffff',
    padding: '12px 16px',
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  },
  img: {
    width: 'auto',
    height: 100,
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <img
        className={classes.img}
        src="/CODE4EV_LOGO_FINAL.png"
        alt="CODE4EV Logo"
      />
    </div>
  );
};

export default LogoFull;
